import { render } from "./RoomProducts.vue?vue&type=template&id=4bcf87b1&scoped=true"
import script from "./RoomProducts.vue?vue&type=script&lang=js"
export * from "./RoomProducts.vue?vue&type=script&lang=js"

import "./RoomProducts.vue?vue&type=style&index=0&id=4bcf87b1&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcf87b1"]])

export default __exports__